import Cookies from "js-cookie";

export const setCookie = (name, content) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  Cookies.set(name, content, { expires: 7 });
};

export const setCookieDay = (name, content, day) => {
  if (!name) return;
  if (typeof content !== "string") {
    content = JSON.stringify(content);
  }
  Cookies.set(name, content, { expires: day });
};

export const getCookie = (name) => {
  if (!name) return;
  return Cookies.get(name);
};

export const removeCookie = (name) => {
  Cookies.remove(name);
};

export const portStartSelect = (item) => {
  let liststart =
    getCookie("portStartCookieWeb") != undefined &&
    getCookie("portStartCookieWeb") != null
      ? JSON.parse(getCookie("portStartCookieWeb"))
      : [];
  let repeat = false;
  for (var i = 0; i < liststart.length; i++) {
    if (liststart[i].id == item.id) {
      repeat = true;
      liststart.splice(i, 1);
      liststart.unshift(item);
      break;
    }
  }
  if (!repeat) {
    if (item.id != null) {
      liststart.unshift(item);
    }
    if (liststart.length > 6) {
      liststart.splice(6, 1);
    }
  }
  setCookie("portStartCookieWeb", liststart);
  return item.id;
};
export const portStartListRefresh = (res, key) => {
  let liststart =
    getCookie("portStartCookieWeb") != undefined &&
    getCookie("portStartCookieWeb") != null
      ? JSON.parse(getCookie("portStartCookieWeb"))
      : [];
  if (liststart.length > 0) {
    if (!key && res && res.length > 0) {
      if (res[0].id == null || res[0].id == "" || res[0].id == undefined) {
        res.splice(0, 1);
      }
      var deleteArr = new Array();
      for (var i = 0; i < res.length; i++) {
        for (var j = 0; j < liststart.length; j++) {
          if (res[i].id == liststart[j].id) {
            deleteArr.push(res[i]);
          }
        }
      }
      for (var k = 0; k < deleteArr.length; k++) {
        res.splice(res.indexOf(deleteArr[k]), 1);
      }
      for (var i = liststart.length - 1; i >= 0; i--) {
        res.unshift(liststart[i]);
      }
    }
  }
  return res;
};
export const portEndSelect = (item) => {
  let listent =
    getCookie("portEndCookieWeb") != undefined &&
    getCookie("portEndCookieWeb") != null
      ? JSON.parse(getCookie("portEndCookieWeb"))
      : [];
  let repeat = false;
  for (var i = 0; i < listent.length; i++) {
    if (listent[i].id == item.id) {
      repeat = true;
      listent.splice(i, 1);
      listent.unshift(item);
      break;
    }
  }
  if (!repeat) {
    if (item.id != null) {
      listent.unshift(item);
    }
    if (listent.length > 6) {
      listent.splice(6, 1);
    }
  }
  setCookie("portEndCookieWeb", listent);
  return item.id;
};
export const portEndListRefresh = (res, key) => {
  let listent =
    getCookie("portEndCookieWeb") != undefined &&
    getCookie("portEndCookieWeb") != null
      ? JSON.parse(getCookie("portEndCookieWeb"))
      : [];
  if (listent.length > 0) {
    if (!key && res && res.length > 0) {
      if (res[0].id == null || res[0].id == "" || res[0].id == undefined) {
        res.splice(0, 1);
      }
      var deleteArr = new Array();
      for (var i = 0; i < res.length; i++) {
        for (var j = 0; j < listent.length; j++) {
          if (res[i].id == listent[j].id) {
            deleteArr.push(res[i]);
          }
        }
      }
      for (var k = 0; k < deleteArr.length; k++) {
        res.splice(res.indexOf(deleteArr[k]), 1);
      }
      for (var i = listent.length - 1; i >= 0; i--) {
        res.unshift(listent[i]);
      }
    }
  }
  return res;
};
